import React, {useEffect, useRef} from 'react';
import {Theme} from '@taopix/taopix-design-system';
import classNames from 'classnames';
import {useRegisterKeyboardCommand} from '../Context/KeyboardCommandsContext';
import {useTranslation} from 'react-i18next';

type HeaderPropTypes = {
  leftSideContent?: any;
  middleContent?: any;
  rightSideContent?: any;
} & React.HTMLAttributes<HTMLDivElement>;

const Header = ({leftSideContent, middleContent, rightSideContent, ...props}: HeaderPropTypes) => {
  const {t} = useTranslation(['*']);

  const headerClassNames = classNames(
    'flex',
    'border-b-themeBorderSize',
    'border-b-themeBorderColour',
    'transition-[transform]'
  );

  const leftButtonGroupClasses = classNames('flex', 'items-center', 'box-border', 'lg:w-[320rem]');

  const middleButtonGroupClasses = classNames('flex', 'items-center', 'box-border');

  const rightButtonGroupClasses = classNames(
    'flex',
    'items-center',
    'lg:py-xs',
    'sm:py-sm',
    'lg:space-x-md',
    'sm:space-x-sm',
    'pr-sm',
    'ml-auto'
  );

  const firstButtonRef = useRef<HTMLButtonElement>();

  // Register the keyboard shortcut for jumping to the first button in the header
  useRegisterKeyboardCommand({
    code: 'Digit1',
    shiftKey: true,
    callback: () => {
      firstButtonRef?.current?.focus();
    },
  });

  useEffect(() => {
    // Get all buttons that are decendents of the header
    const buttons = document.querySelectorAll('#' + props.id + ' button');

    // Assign first button ref
    firstButtonRef.current = buttons[0] as HTMLButtonElement;
  }, [props.id]);

  return (
    <Theme
      element={'header'}
      aria-label={t('*:str_LabelAppHeader', {defaultValue: 'Appl header'})}
      name={'tpx-theme-header'}
      tipLabel={'Header'}
      isRootTheme
      allowBorder={false}
      allowCorners={false}
      className={headerClassNames}
      id={props.id}
    >
      {leftSideContent && <div className={leftButtonGroupClasses}>{leftSideContent}</div>}
      {middleContent && <div className={middleButtonGroupClasses}>{middleContent}</div>}
      {rightSideContent && <div className={rightButtonGroupClasses}>{rightSideContent}</div>}
    </Theme>
  );
};

export default Header;
